import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cp-commission-maintenance',
    templateUrl: './commission-maintenance.component.html',
    styleUrls: ['./commission-maintenance.component.scss'],
    standalone: false
})
export class CommissionMaintenanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
